import { Link } from "react-router-dom";

export interface NavItem {
  label: string;
  path: string;
}

export const NAV_ITEMS: NavItem[] = [
  { label: "메인", path: "/" },
  { label: "샵 소개", path: "/about" },
  { label: "피부관리 프로그램", path: "/programs" },
  { label: "뷰티정보", path: "/beauty-info" },
  { label: "예약 상담", path: "/reservation" },
];

export const PHONE_NUMBER = "02-002-2525";
export const PHONE_TEL = "tel:02-002-2525";